export const bankAccountMutationSitecoreLabels = {
  HeadingIban: { value: "Nieuw IBAN" },
  InfoIban: { value: "" },
  PlaceholderIban: { value: "Nieuw IBAN" },
  TooltipIban: { value: "" },
  HeadingCurrentIban: { value: "Huidig IBAN" },
  InfoCurrentIban: { value: "" },
  PlaceholderCurrentIban: { value: "" },
  TooltipCurrentIban: { value: "" },
};
